import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import AttachmentOrderForm, {
  AttachmentOrderFormRef,
  AttachmentOrderFormValues,
} from './AttachmentOrderForm';

type CreateAttachmentOrderProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: AttachmentOrderFormValues) => Promise<void>;
};

const CreateAttachmentOrderModal: React.FC<CreateAttachmentOrderProps> = ({
  isOpen,
  toggle,
  onSubmit,
}: CreateAttachmentOrderProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<AttachmentOrderFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: AttachmentOrderFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.createAttachmentOrder']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <AttachmentOrderForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreateAttachmentOrderModal;
